import React, { useState } from 'react';
import PoweredBy from '../../common/powered-by';
import { useTranslation } from 'react-i18next';
import { commaSeperatedAmount } from '../../common';
import { CURRENCY_SYMBOL } from '../../common';


const Footer = ({ isSkipButtonVisible, handleNext, handleSkip, disabled, totalPayable, btnName, CustomClass }) => {
    const [btnText, setBtnText] = useState(btnName ?? "Next");
    const { t } = useTranslation()


    return (
        <footer className={`footer ${CustomClass}`} id="footer">
           <ul className={`footer-ul ${(isSkipButtonVisible || totalPayable ||(totalPayable==0) ) ? "" : "skip-inactive"}`}>
                {isSkipButtonVisible && (
                    <li className="footer-li footer-skip">
                        <button className="btn btn-transparent footer-menu" onClick={handleSkip}>
                            Skip
                        </button>
                    </li>
                )}
                {
                    (totalPayable || (totalPayable==0) )&&(
                    <li className="footer-li footer-totalPayable">
                        <p className='text-opacity'>Total Payable
                            {/* {t('Total_payable_zakat_label')} */}
                        </p>
                        <h2 className='amt-pay text-primary' id='total-payable-zakat'>{commaSeperatedAmount(CURRENCY_SYMBOL, String(totalPayable).replace(/[$,]/g, ''))}</h2>
                    </li>
                )}

                <li className="footer-li footer-btn">
                    <button className="btn footer-menu" onClick={handleNext} disabled={disabled ?? false}>
                        {btnText}
                    </button>
                </li>
            </ul>
            <PoweredBy />
        </footer>
    );
};

export default Footer;